// const domain: string = 'https://www.duma-dev.com'
// const domain: string = 'https://www.autobet.pro'
const domain: string = window.location.origin
const fetchGet = async (url: string, params = {}, bearerToken = null) => {
    const query = new URLSearchParams(params).toString()
    url = `${domain}${url}`
    if (query) {
        url = `${url}?${query}`
    }

    const request = {
        method: 'GET',
        headers: {
            'Authorization': 'Bearer ' + bearerToken || ''
        },
    }

    return fetch(url, request).then(r => r.json())
}

const fetchPost = async (url: string, form: any, bearerToken = null) => {
    url = `${domain}${url}`
    const notifications_token = localStorage.getItem('notifications_token')
    const request = {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-notifications-token': notifications_token || '',
            'Authorization': 'Bearer ' + bearerToken || ''
        },
        body: JSON.stringify(form)
    }

    return fetch(url, request).then(r => r.json())
}

const api = {
    getDashboard: async () => fetchGet('/backend/dashboard/data/'),

    register: async (user: any) => fetchPost(`/backend/auth/register`, {
        ...user
    }),
    login: async (user: any) => fetchPost(`/backend/auth/login`, {
        ...user
    }),
    getAuthUser: async (token: string) => fetchGet(`/backend/auth/user`, {}, token),

    getTipsDaily: async () => fetchGet('/backend/tips/daily/'),
    getTipsDailyHistory: async (page = 0, limit = 0) => fetchGet(`/backend/tips/daily-history/`, { page, limit }),

    getTipsLive: async () => fetchGet('/backend/tips/live/'),
    getTipsLiveHistory: async (today = false, page = 0, limit = 0) => fetchGet(`/backend/tips/live-history/`, {
        today,
        page,
        limit
    }),

    subscribeNotifications: async (token: string, user_agent: string, timezone: string) => fetchPost(`/backend/notifications/subscribe/`, {
        token, user_agent, timezone
    }),
    saveNotificationsSettings: async (settings: any) => fetchPost(`/backend/notifications/settings/`, {
        settings
    }),

    getFixtures: async () => fetchGet('/backend/fixtures/list/'),
    getFixtureDetails: async (id: number) => fetchGet(`/backend/fixtures/details?fixtureId=${id}`),
    getFixtureDetailsFromSofascore: async (id: number) => fetch(`https://www.sofascore.com/api/v1/event/${id}`).then(r => r.json()),
    getHeadToHeadFixtures: async (id: number) => fetchGet(`/backend/fixtures/headToHead?fixtureId=${id}&limit=7`),
    getLastGamesTeam: async (id: number) => fetchGet(`/backend/fixtures/lastGamesTeam?teamId=${id}&limit=7`),
    getMomentum: async (id: number) => fetchGet(`/backend/fixtures/momentum?fixtureId=${id}`),
    getOdds: async (id: number) => fetchGet(`/backend/fixtures/odds?eventId=${id}`),
    getSorter: async () => fetchGet(`/backend/fixtures/sorter`),
    updateGameStatus: async (id: number, gameId: number, status: string) => fetchPost(`/backend/tips/updateStatus`, {
        id, gameId, status
    }, localStorage.getItem('authToken')),
}
export default api
